/**
 * Portal Manta · RelatoriosStandalonePage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { V, extKm } from '../../globals.js';
import { NovoEstudoFluxoPage } from '../novo-estudo/NovoEstudoFluxoPage.jsx';
import { featuresDoLote } from '../agentes/featuresDoLote.jsx';
import { featuresDoExtra } from '../agentes/featuresDoExtra.jsx';
import { RelatoriosPage } from './RelatoriosPage.jsx';
import { loadKbExtras, loadOrcGerados } from '../../app-globals.js';

const RelatoriosStandalonePage = memo(function RelatoriosStandalonePage_Inner(){
  // Ler estudo atual do localStorage (mesmo que NovoEstudoFluxoPage)
  const [qual] = useState(() => {
    try {
      const raw = localStorage.getItem('manta-novo-estudo-qual');
      return raw ? JSON.parse(raw) : {nome:'', codManta:'', uf:'PR', ufPrincipal:'PR'};
    } catch(e){ return {nome:'', codManta:'', uf:'PR', ufPrincipal:'PR'}; }
  });
  const [kpis] = useState(() => {
    try {
      const raw = localStorage.getItem('manta-novo-estudo-kpis');
      return raw ? JSON.parse(raw) : {extKm:0, dupKm:0, oaeQt:0, interQt:0, passQt:0};
    } catch(e){ return {extKm:0, dupKm:0, oaeQt:0, interQt:0, passQt:0}; }
  });
  const [fontes] = useState(() => {
    try {
      const raw = localStorage.getItem('manta-novo-estudo-fontes');
      return raw ? JSON.parse(raw) : {};
    } catch(e){ return {}; }
  });
  const [kbExtras] = useState(() => loadKbExtras());
  const [salvosHist] = useState(() => loadOrcGerados());

  // Base de lotes (oficiais + extras)
  const baseLotes = useMemo(() => {
    const oficiais = ['3','4','5'].map(featuresDoLote);
    const extras = kbExtras.map(featuresDoExtra);
    return [...oficiais, ...extras];
  }, [kbExtras]);

  // Status do estudo atual
  const estudoCarregado = qual.nome || qual.codManta;
  const totalQuali = Object.values(qual || {}).filter(v => v !== '' && v !== 0 && v != null).length;
  const totalQuanti = Object.values(kpis || {}).filter(v => v !== 0 && v != null).length;

  return (<div style={{padding:'24px 28px', maxWidth:1280, margin:'0 auto', fontFamily:F.body}}>
    {/* Header */}
    <div style={{marginBottom:18}}>
      <div style={{
        fontFamily:F.display, fontSize:22, fontWeight:600, color:M.title,
        marginBottom:5, paddingBottom:7, borderBottom:`2px solid ${M.borderSoft}`,
        display:'flex', alignItems:'baseline', gap:14,
      }}>
        <span style={{
          fontFamily:F.mono, fontSize:11, color:'#fff', fontWeight:700,
          padding:'4px 11px', background:M.accent, letterSpacing:1, flexShrink:0,
        }}>07</span>
        📊 Relatórios
      </div>
      <div style={{fontSize:11.5, color:M.muted, lineHeight:1.5}}>
        10 relatórios pré-configurados · Grupo A (estudo atual) + Grupo B (portfolio consolidado).
        Acesso rápido sem precisar entrar no fluxo de "Novo Estudo".
      </div>
    </div>

    {/* Status do estudo atual */}
    <div style={{
      marginBottom:18, padding:'12px 16px',
      background: estudoCarregado ? '#D1FAE5' : '#FEF3C7',
      border: `1px solid ${estudoCarregado ? '#10B981' : '#F59E0B'}`,
      borderRadius:4, display:'flex', alignItems:'center', gap:12,
    }}>
      <span style={{fontSize:22}}>{estudoCarregado ? '✅' : '⚠️'}</span>
      <div style={{flex:1}}>
        <div style={{fontWeight:700, fontSize:13, color: estudoCarregado ? '#065F46' : '#92400E'}}>
          {estudoCarregado ? (qual.nome || qual.codManta) : 'Nenhum estudo carregado'}
        </div>
        <div style={{fontSize:11, color: estudoCarregado ? '#047857' : '#92400E', marginTop:2}}>
          {estudoCarregado ? (
            <>📐 {totalQuali} campos qualitativos · 📊 {totalQuanti} campos quantitativos · 📁 {salvosHist.length} estudos no histórico · 🗂 {baseLotes.length} lotes na base</>
          ) : (
            <>Vá para <b>"05 · Novo Estudo"</b> → clique em <b>"🚀 INICIAR LOTE 1 PR"</b> ou preencha manualmente. Os relatórios do Grupo A precisam de um estudo. Os do Grupo B podem rodar com a base de lotes histórica.</>
          )}
        </div>
      </div>
    </div>

    {/* Renderizar a página de relatórios (mesma do Novo Estudo) · sem similaridades calculadas
        nessa view standalone para não recomputar tudo · usuário pode ir pro fluxo completo se quiser */}
    <RelatoriosPage
      qual={qual} kpis={kpis} fontes={fontes}
      orcamento={null}
      loteRef={null}
      similaridades={[]}
      casosFiltrados={[]}
      salvosHist={salvosHist}
      baseLotes={baseLotes}
    />

    {/* Dica */}
    <div style={{
      marginTop:18, padding:'10px 14px', background:M.bgAlt,
      border:`1px solid ${M.borderSoft}`, borderRadius:4,
      fontSize:11, color:M.muted, lineHeight:1.5,
    }}>
      <b style={{color:M.title}}>💡 Dica:</b> os relatórios <b>A2</b> (Resumo Executivo) e <b>A5</b> (Backup JSON) referenciam <i>similaridades</i> e <i>orçamento</i> que só são calculados no fluxo <b>"05 · Novo Estudo → 3. Orçamentação"</b>. Para esses relatórios completos, use a sub-aba <b>"📊 5. Relatórios"</b> dentro de Novo Estudo.
    </div>
  </div>);
});

export { RelatoriosStandalonePage };
export default RelatoriosStandalonePage;
